(() => {
  const setup = () => {
    const controller = document.querySelector("[data-lehuo-load-more]");
    const grid = document.querySelector("[data-lehuo-product-grid]");
    const sentinel = controller?.querySelector("[data-load-more-sentinel]");
    const nextLink = controller?.querySelector("[data-load-more-next]");
    const status = controller?.querySelector("[data-load-more-status]");
    const pageLabel = controller?.querySelector("[data-load-more-page]");
    const progress = controller?.querySelector("[data-load-more-progress]");
    if (!controller || !grid || !sentinel || !nextLink || !status) return;

    let loading = false;
    let currentPage = Number(controller.dataset.currentPage || 1);
    const totalPages = Number(controller.dataset.totalPages || currentPage);
    let scrollQueued = false;
    const knownProductUrls = new Set(
      Array.from(grid.querySelectorAll("a.lehuo-product-card[href]")).map((card) => card.getAttribute("href")),
    );

    const updateProgress = () => {
      if (pageLabel) pageLabel.textContent = String(currentPage);
      if (progress) progress.style.width = `${Math.min((currentPage / totalPages) * 100, 100)}%`;
    };

    const appendUniqueProducts = (nextGrid) => {
      Array.from(nextGrid.children).forEach((card) => {
        const productUrl = card.matches("a.lehuo-product-card[href]") ? card.getAttribute("href") : "";
        if (productUrl && knownProductUrls.has(productUrl)) return;
        if (productUrl) knownProductUrls.add(productUrl);
        grid.appendChild(document.importNode(card, true));
      });
    };

    const loadNextPage = async () => {
      const nextHref = nextLink.getAttribute("href");
      if (loading || !nextHref) return;
      loading = true;
      controller.setAttribute("aria-busy", "true");
      status.textContent = "Loading more products…";

      try {
        const response = await fetch(new URL(nextHref, window.location.origin), { credentials: "same-origin" });
        if (!response.ok) throw new Error("Unable to load the next product page.");

        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = nextDocument.querySelector("[data-lehuo-product-grid]");
        if (!nextGrid) throw new Error("Product grid was not found.");

        appendUniqueProducts(nextGrid);
        currentPage += 1;
        updateProgress();

        const followingUrl = nextDocument.querySelector("[data-load-more-next]")?.getAttribute("href");
        if (followingUrl) {
          nextLink.setAttribute("href", followingUrl);
          status.innerHTML = `Page <span data-load-more-page>${currentPage}</span> of ${totalPages} · More products load automatically`;
          loading = false;
          controller.removeAttribute("aria-busy");
          observer.unobserve(sentinel);
          observer.observe(sentinel);
        } else {
          observer.disconnect();
          nextLink.removeAttribute("href");
          sentinel.remove();
          status.textContent = `All products loaded · ${currentPage} of ${totalPages} pages`;
          status.classList.add("lehuo-load-more__complete");
          controller.removeAttribute("aria-busy");
        }
      } catch {
        loading = false;
        controller.removeAttribute("aria-busy");
        status.textContent = "Keep scrolling to retry";
        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
      },
      { rootMargin: "900px 0px" },
    );

    observer.observe(sentinel);

    const checkScrollPosition = () => {
      scrollQueued = false;
      if (sentinel.isConnected && sentinel.getBoundingClientRect().top < window.innerHeight + 1200) {
        loadNextPage();
      }
    };

    window.addEventListener(
      "scroll",
      () => {
        if (scrollQueued) return;
        scrollQueued = true;
        window.requestAnimationFrame(checkScrollPosition);
      },
      { passive: true },
    );
    window.setTimeout(checkScrollPosition, 350);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup, { once: true });
  } else {
    setup();
  }
})();
